export const addDatacyToCell =
  (key: string) =>
  ({ id }: { id: string }) =>
    ({ 'data-cy': `${key}-${id}` } as React.HTMLAttributes<HTMLElement>);

export const addDatacyToTableHeader = (key: string) => () =>
  ({ 'data-cy': `${key}-header` } as React.HTMLAttributes<HTMLElement>);
